import { Scope } from "../../models/Scope";
import AxiosService from "../axios-service/AxiosService";
import Storage from "../storage-service/Storage";

const MANAGER_BFF_URL = process.env.REACT_APP_MANAGER_BFF_URL;

type CreateScopeType = Pick<Scope, "name" | "description">;

export default class ScopeService {
    static findAll = async (): Promise<Scope[]> => {
        const token = Storage.get(Storage.KEYS.USERTOKEN);
        const options = {
            headers: {
                authorization: token
            }
        };
        const url = `${MANAGER_BFF_URL}/v1/scopes`;
        const response = await AxiosService.httpGet(url, options);
        return response.data;
    };

    static createScope = async (data: CreateScopeType): Promise<Scope[]> => {
        const token = Storage.get(Storage.KEYS.USERTOKEN);
        const options = {
            headers: {
                authorization: token
            }
        };
        const url = `${MANAGER_BFF_URL}/v1/scopes`;
        const response = await AxiosService.httpPost(url, data, options);
        return response.data;
    };
}
